import React, { Component } from "react";
import snippet3 from './data-forumsnippet3.js';

import './whatson.css';

class ForumSnippet3 extends Component {

  render() {
    return (
        <div className="snippet3">
            
        {snippet3.map(item =>
        <a href={item.url}>
        <div key={item.objectID}>
        <h1>{item.title}</h1>
        <p><a href={item.url}>{item.data}</a></p>
        <br></br>
        <a href={item.url}><img src={item.imgurl} alt="snippet3"/></a>
        </div>
        </a>
            )}
        </div>
        );
}
}
  

export default ForumSnippet3;



// WEBPACK FOOTER //
// ./src/ForumSnippet3.js